<template>
    <div>
        <v-list-item
                v-if="messageAll"
                @click.stop="dialog = true">
            <v-list-item-title>Message All</v-list-item-title>
        </v-list-item>
        <v-btn
                v-else
                depressed class="primary"
                @click.stop="dialog = true">
            <v-icon left>mdi-post</v-icon>
            Publish a New Post
        </v-btn>
        <v-dialog width="600px" v-model="dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">Publish a New Post</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text>
                    <v-container class="pl-0 pr-0">
                        <v-form ref="form"
                                v-model="valid"
                                validation>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-col cols="12" sm="12" class="area-select">
                                        <v-select
                                                outlined
                                                label="To*"
                                                required
                                                :readonly="messageAll"
                                                :disabled="messageAll"
                                                v-model="addresseeSelect"
                                                :items="addresseeList"
                                                item-value="id"
                                                item-text="value"
                                                @change="resetAddresseeData"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" class="area-select" v-if="addresseeSelect === ADDRESS_TO_RESTAURANTS">
                                        <v-autocomplete
                                                outlined
                                                label="Select (a) Restaurant(s)"
                                                required
                                                deletable-chips
                                                multiple
                                                chips
                                                :readonly="messageAll"
                                                :disabled="messageAll"
                                                v-model="restaurantsSelected"
                                                :items="restaurantsList"
                                                item-value="id"
                                                item-text="name"
                                                @change="setRestaurantAsAddressee"
                                                :rules="restaurantSelectRules"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" class="area-select" v-if="addresseeSelect === ADDRESS_TO_AREAS">
                                        <v-autocomplete
                                                outlined
                                                label="Select (an) Area(s)"
                                                required
                                                deletable-chips
                                                multiple
                                                chips
                                                v-model="areasSelected"
                                                :items="areasList"
                                                item-value="id"
                                                item-text="name"
                                                @change="setAreaAsAddressee"
                                                :rules="areaSelectRules"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" class="area-select" v-if="addresseeSelect === ADDRESS_TO_DRIVERS">
                                        <v-autocomplete
                                                outlined
                                                label="Select (a) Driver(s)"
                                                required
                                                deletable-chips
                                                multiple
                                                chips
                                                v-model="driversSelected"
                                                :items="driversList"
                                                item-value="id"
                                                item-text="full_name"
                                                @change="setDriverAsAddressee"
                                                :rules="driverSelectRules"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                name="Post Title"
                                                label="Post Title*"
                                                outlined
                                                v-model="postTitle"
                                                :rules="postTitleRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <tiptap-vuetify
                                            v-model="postContent"
                                            placeholder="Post Content*"
                                            :extensions="extensions"
                                            @keydown="postContentModifed"
                                        />
                                        <div class="v-messages theme--light error--text" v-if="this.postContentDirty && !isPostContentValid">
                                            Please enter post content
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-file-input
                                                :rules="imgRules"
                                                accept="image/png, image/jpeg, image/jpg, image/bmp"
                                                placeholder="Upload a file"
                                                prepend-icon="mdi-camera"
                                                label="File"
                                                ref="image"
                                                @change="onChangeFileUpload"
                                        ></v-file-input>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                                v-model="checkbox"
                                                :true-value="IMPORTANT_YES"
                                                :false-value="IMPORTANT_DEFAULT"
                                                :label="`Important`"
                                        ></v-checkbox>
                                    </v-col>
                                </v-flex>
                            </v-layout>

                            <div class="d-flex justify-center">
                                <v-btn
                                        color="primary"
                                        depressed
                                        class="mr-4"
                                        :disabled="!valid || localLoading || !isPostContentValid"
                                        @click="submit"
                                        :loading="localLoading"
                                ><v-icon left>mdi-publish</v-icon>Publish</v-btn>
                                <v-btn
                                        color="warning"
                                        depressed
                                        @click="clear"
                                        :loading="localLoading"
                                ><v-icon left>mdi-cancel</v-icon>Clear</v-btn>
                            </div>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'
    import { TiptapVuetify, Bold, Italic,/* Strike,*/ Underline } from 'tiptap-vuetify'
    import { IMPORTANT_YES, IMPORTANT_DEFAULT } from '../../store/posts';

    const ADDRESS_TO_ALL = 10;
    const ADDRESS_TO_AREAS = 20;
    const ADDRESS_TO_RESTAURANTS = 30;
    const ADDRESS_TO_DRIVERS = 40;

    export default {
        components: { TiptapVuetify },
        name: "NewPostModal",
        props: ['restaurantId','postsList'],
        data(){
            return{
                checkbox: IMPORTANT_DEFAULT,
                file: {},
                dialog: false,
                messageAll: false,
                ADDRESS_TO_ALL: ADDRESS_TO_ALL,
                ADDRESS_TO_AREAS: ADDRESS_TO_AREAS,
                ADDRESS_TO_RESTAURANTS: ADDRESS_TO_RESTAURANTS,
                ADDRESS_TO_DRIVERS: ADDRESS_TO_DRIVERS,
                postTitle: '',
                postContent: '',
                postContentDirty: false,
                addresseeSelect: ADDRESS_TO_ALL,
                addresseeList: [
                    {
                        id: ADDRESS_TO_ALL,
                        value: 'All',
                    }, {
                        id: ADDRESS_TO_AREAS,
                        value: 'Selected Areas',
                    }, {
                        id: ADDRESS_TO_RESTAURANTS,
                        value: 'Selected Restaurants',
                    }, {
                        id: ADDRESS_TO_DRIVERS,
                        value: 'Selected Driver(s)'
                    },
                ],
                areasSelected: [],
                restaurantsSelected: [],
                driversSelected: [],
                valid: false,
                localLoading: false,
                postTitleRules: [
                    v => !!v || 'Please enter post title',
                ],
                postContentRules: [
                    v => !!v || 'Please enter post content',
                ],
                restaurantSelectRules: [
                    v => !!v || 'Please select a restaurant',
                ],
                areaSelectRules: [
                    v => !!v || 'Please select an area',
                ],
                driverSelectRules: [
                    v => !!v || 'Please select (a) driver(s)',
                ],
                imgRules: [
                    value => {
                        if (value && value.size > 10000000) {
                            return 'File size should be less than 10 MB!';
                        }
                        return true;
                    }
                ],
                extensions: [
                    Underline,
                    Italic,
                    Bold,
                    // Strike,
                ],
                IMPORTANT_YES: IMPORTANT_YES,
                IMPORTANT_DEFAULT: IMPORTANT_DEFAULT,
            }
        },
        created() {
            if (this.restaurantId) {
                this.addresseeSelect = ADDRESS_TO_RESTAURANTS;
                this.restaurantsSelected = [+this.restaurantId];
                this.messageAll = true
            }
        },
        computed: {
            ...mapGetters([
                'restaurants',
                'areas',
                'drivers',
            ]),
            areasList() {
                return this.areas;
            },
            restaurantsList() {
                return this.restaurants;
            },
            driversList() {
                return this.drivers;
            },
            isPostContentValid() {
                return !!this.postContent && this.postContent != '<p></p>';
            },
            // user(){
            //     return JSON.parse(localStorage.getItem('user'));
            // },
        },
        methods: {
            onChangeFileUpload(file){
               this.file = file;
            },
            resetAddresseeData() {
                this.areasSelected = [];
                this.restaurantsSelected = [];
                this.driversSelected = [];
            },
            setAreaAsAddressee(/*name*/) {
                // --
            },
            setRestaurantAsAddressee(/*name*/) {
                // --
            },
            setDriverAsAddressee(/*name*/) {
                // --
            },
            postContentModifed(/* event, view */) {
                Vue.nextTick(() => {
                    if (this.postContent == '<p></p>') {
                        this.postContent = '';
                    }
                });

                this.postContentDirty = true;
            },

            submit () {
                if (this.$refs.form.validate()) {
                    this.localLoading = true;
                    let formData = new FormData();
                    formData.append('file',this.file);
                    formData.append('postTitle', this.postTitle);
                    formData.append('postContent', this.postContent);
                    
                    if (!_.isEmpty(this.areasSelected)) {
                        formData.append('areas', JSON.stringify(this.areasSelected));
                    }

                    if (!_.isEmpty(this.restaurantsSelected)) {
                        formData.append('restaurants', JSON.stringify(this.restaurantsSelected));
                    }

                    if (!_.isEmpty(this.driversSelected)) {
                        formData.append('drivers', JSON.stringify(this.driversSelected));
                    }

                    // formData.append('addressee', this.addressee);
                    formData.append('important', this.checkbox);

                    this.$store.dispatch('createNewPost', formData)
                        .then((/* data */) => {
                            this.dialog = false;
                            
                            this.clear();
                        })
                        .finally(() => {
                            this.localLoading = false;
                        })
                }
            },
            clear() {
                // reset form data
                this.checkbox = false;
                this.addresseeSelect = ADDRESS_TO_ALL;
                this.areasSelected = [];
                this.restaurantsSelected = [];
                this.driversSelected = [];
                this.postTitle = '';
                this.postContent = '';
                this.postContentDirty = false;
                this.file = {};

                // reset validation
                this.$refs.form.reset();
            },
        },
    }
</script>

<style scoped>

</style>

<style>
    .ProseMirror {
        min-height: 150px;
        padding: 8px;
    }

    .ProseMirror p {
        margin-bottom: auto;
    }
</style>